// extracted by css-extract-rspack-plugin
export default {"cls1":"CoauthorConfirmationCard-cls1_llv","cls2":"CoauthorConfirmationCard-cls2_GNJ CoauthorConfirmationCard-cls1_llv"};